import { configureStore } from '@reduxjs/toolkit';

import { secretApi } from '@/api/secretApi';

export const store = configureStore({
    reducer: {
        [secretApi.reducerPath]: secretApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(secretApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
